import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteNestedOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, value, valueToDelete }) => {
      if (name && value) {
        return api.delete(`options/${name}-${value}/values`, {
          json: { value: valueToDelete },
        });
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['options'] }),
  });
}
